export default "__VITE_PUBLIC_ASSET__0f922c67__"